import './App.css';
import { Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import NuevaReservacion from './components/NuevaReservacion';
import CompletarReservacion from './components/CompletarReservacion';
import ConsultarReservacion from './components/ConsultarReservacion';
import ResumenReservacion from './components/ResumenReservacion';
import AdminLayout from './components/AdminLayout';
import ListaReservasPendientes from './components/ListaReservasPendientes';
import PaginaSolicitudesPendientes from './pages/PaginaSolicitudesPendientes';
import Presentacion from './components/Presentacion';
import CalendarioReservas from './components/CalendarioReservas';
import TodasSolicitudes from './components/TodasSolicitudes';
import ReservaInterna from './components/ReservaInterna';
import PrivateRoute from './components/PrivateRoute';
import AuthCallback from './components/AuthCallback';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PaginaDetallesCita from './pages/PaginaDetallesCita';
import './utils/style/variables.css';
import PaginaReservacion from './pages/PaginaReservacion';
import { AlertProvider } from './context/AlertContext';
import RegistroLlegada from './components/RegistroLlegada';

function App() {
  
  return (
    <AlertProvider>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/nueva-reservacion" element={<NuevaReservacion />} />
        <Route path="/completar-reservacion" element={<CompletarReservacion />} />
        <Route path="/consultar-reservacion" element={<ConsultarReservacion />} />
        <Route path="/resumen/:folio" element={<ResumenReservacion/>} />
        <Route path="/reservacion/:folio" element={<PaginaReservacion/>} />

        {/* Ruta para el login */}
        <Route path="/login" element={<Login />} />
        {/* Ruta para el callback después de autenticarse con Azure */}
        <Route path="/auth/redirect" element={<AuthCallback />} />

        <Route path="/dashboard" element={<Dashboard />} />

        <Route
        path="/admin/*"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Presentacion />} />
        <Route path="dashboard" element={<Presentacion />} />
        <Route path="pendientes" element={<ListaReservasPendientes />} />
        <Route path="pendientes/:folio" element={<PaginaSolicitudesPendientes />} />
        <Route path="calendario" element={<CalendarioReservas />} />
        <Route path="calendario/:folio" element={<PaginaDetallesCita />} />
        <Route path="todas" element={<TodasSolicitudes />} />
        <Route path="reserva-interna" element={<ReservaInterna />} />
        <Route path="llegadas" element={<RegistroLlegada />} />
      </Route>
    </Routes>
    </AlertProvider>

  );
}

export default App;
